import React from "react";
import chunk from "lodash/chunk";
import { DomParser } from "../utils/dom-parser";
import { renderDate } from "../utils/text-display";
import { WidgetBox, Empty, Link, Action } from "../components";

const Certifications = ({ title = "Certifications" }) => {
    const parseDataFromDOM = () => {
        const domParser = new DomParser(
            "table[summary='My Certifications Content'] > tbody > tr > td"
        );
        const columns = [];

        domParser.cols.forEach(o => {
            if (o.querySelector("br") === null) {
                columns.push(o);
            }
        });

        return chunk(columns, 3)
            .map(row => {
                const [td1, td2, td3] = row;
                const link = domParser.singleAnchor(td1);

                return {
                    link,
                    dueDate: domParser.dateSpan(td2),
                    expiration: domParser.textSpan(td3)
                };
            })
            .sort((a, b) => a.dueDate - b.dueDate);
    };

    const data = parseDataFromDOM();

    let titleLink = null;
    let titleLinkEl = document.querySelector(
        "div[data-tag='pnlCertification'] a.titleLink"
    );

    if (titleLinkEl) {
        titleLink = titleLinkEl.getAttribute("href");
    }

    return (
        <WidgetBox
            title={title}
            type="meadow"
            noPadding
            floatingImg="pin"
            titleLink={titleLink}
        >
            <div className="v-list">
                <div style={{ margin: "0px 45px" }}>
                    <Empty isEmpty={data.length === 0} />
                </div>
                {data.map((o, i) => (
                    <div key={i} className="v-list-item v-list-item--alternate">
                        <Action classes="v-list-item__title" {...o.link} />
                        <p className="v-list-item__date">
                            {renderDate(o.dueDate, "Due date: ", true)}
                        </p>
                        <p className="v-list-item__date">
                            {renderDate(o.expiration, "Expiration: ", true)}
                        </p>
                    </div>
                ))}
            </div>
            {titleLink && (
                <div style={{ padding: "0px 45px 25px 45px" }}>
                    <Link text="See all certifications" url={titleLink} />
                </div>
            )}
        </WidgetBox>
    );
};

export default Certifications;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/widgets/certifications.js